import * as React from 'react';
import teamsnapSdk from 'utils/teamsnapSdk';

import styles from './EmailVerificationBanner.module.scss';

const EmailVerificationBanner = () => {
  const [currentUser, setCurrentUser] = React.useState(null);
  const [emailValidationSent, setEmailValidationSent] = React.useState(false);
  const [resendError, setResendError] = React.useState(false);

  React.useEffect(() => {
    teamsnapSdk().loadMe().then(user => setCurrentUser(user), () => {});
  }, []);

  const handleResendValidation = () => {
    setResendError(false);
    teamsnapSdk()
      .sendEmailValidation({})
      .then(
        () => {
          setEmailValidationSent(true);
        },
        () => {
          setResendError(true);
        },
      );
  };

  if (!currentUser || currentUser.canSendMessages) {
    return null;
  }

  if (emailValidationSent) {
    return (
      <div className={styles.successBanner}>
        Validation email has been re-sent. Check your email inbox!
      </div>
    );
  }

  return (
    <div className={styles.errorBanner}>
      <strong>Verify Your Email: </strong>
      Before you can send a message, we need to confirm you&apos;re not a robot. A verification
      email was sent to <strong>{currentUser.email}</strong>.&nbsp;
      <button type="button" className={styles.linkButton} onClick={handleResendValidation}>Resend</button>
      {' | '}
      <a href="https://accounts.teamsnap.com/settings/login" target="_blank" rel="noopener noreferrer">Wrong Email?</a>
      {resendError && (
        <div>There was a problem resending the validation email. Please try again.</div>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
